import { render } from "./realEstateWorld.vue?vue&type=template&id=6bfb3c9b&scoped=true"
import script from "./realEstateWorld.vue?vue&type=script&lang=js"
export * from "./realEstateWorld.vue?vue&type=script&lang=js"

import "./realEstateWorld.vue?vue&type=style&index=0&id=6bfb3c9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfb3c9b"]])

export default __exports__